import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import SettingsForm from "../../SettingsForm";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import SwitchRoot from "../../../../components/UI/SwitchRoot";
import Switch from "../../../../components/UI/switch";
import Wrapper from "../../../../components/UI/common/Wrapper";
import ImageSelect from "../../../../components/UI/ImageSelect";
import ButtonSet from "../../../../components/UI/ButtonSet";
import { btnSkins } from "../../../../others/btnSkins";

export default function GeneralSettings() {
    const { settings, getSection, getOption, handleToggle, handleInputChange } =
        useSettingsContext();

    const sectionID = "general";
    const section = getSection(sectionID);

    // console.log(settings);

    return (
        <SettingsForm
            title={__(
                "General Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Configure the basic settings for quantity buttons.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <FieldWrapper
                label={__(
                    "Display Type",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Set the quantity display type.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                width="160"
                containerClass=""
                fieldsClass=""
                direction="vertical"
            >
                <ButtonSet
                    name="qtyDisplayType"
                    value={getOption("qtyDisplayType", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                    options={[
                        {
                            value: "buttons",
                            label: __(
                                "Buttons",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "slider",
                            label: __(
                                "Slider",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                        {
                            value: "default",
                            label: __(
                                "Theme Default",
                                "wpbean-quantity-controls-for-woocommerce",
                            ),
                        },
                    ]}
                />
            </FieldWrapper>
            {getOption("qtyDisplayType", sectionID) === "buttons" && (
                <FieldWrapper
                    label={__(
                        "Button Skin",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "Set a skin that you want for the quantity buttons.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    width="100"
                    containerClass="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-4 items-center"
                >
                    <ImageSelect
                        options={btnSkins}
                        name="btnSkin"
                        value={getOption("btnSkin", sectionID)}
                        onChange={(key, value) =>
                            handleInputChange(section, key, value)
                        }
                        placeholder={__(
                            "Select a skin",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    />
                </FieldWrapper>
            )}

            <Wrapper
                title={__(
                    "Quantity Field Visibility Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <SwitchRoot
                        label={__(
                            "Product Page",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Enable if you wish to replace the default quantity field with this on your single product page.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    >
                        <Switch
                            checked={getOption("productPage", sectionID)}
                            onChange={(value) =>
                                handleToggle(section, "productPage", value)
                            }
                        />
                    </SwitchRoot>
                    <SwitchRoot
                        label={__(
                            "Shop Page",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Check this to show the quantity field for the WooCommerce shop page.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    >
                        <Switch
                            checked={getOption("shopPage", sectionID)}
                            onChange={(value) =>
                                handleToggle(section, "shopPage", value)
                            }
                        />
                    </SwitchRoot>
                    <SwitchRoot
                        label={__(
                            "Archive Page",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Check this to show the quantity field for the WooCommerce archive page.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    >
                        <Switch
                            checked={getOption("archivePage", sectionID)}
                            onChange={(value) =>
                                handleToggle(section, "archivePage", value)
                            }
                        />
                    </SwitchRoot>

                    <SwitchRoot
                        label={__(
                            "Cart Page",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Check this to show the quantity field for the cart page products.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    >
                        <Switch
                            checked={getOption("cartPage", sectionID)}
                            onChange={(value) =>
                                handleToggle(section, "cartPage", value)
                            }
                        />
                    </SwitchRoot>
                </>
            </Wrapper>
        </SettingsForm>
    );
}
